import loadable from "@loadable/component";
import type { FC, PropsWithChildren } from "react";

import { configureHtmlText } from "../../packages/HtmlText";

import {
	DesktopBreakpoint,
	MobileBreakpoint,
	TabletBreakpoint,
	XLDesktopBreakpoint,
} from "../breakpoints";

import type TextProps from "./index.types";

const InlineDisclaimer = loadable(
	() => import("../../_nextgen/components/Disclaimer"),
	{
		resolveComponent: (components) => components.InlineDisclaimer,
	},
);

const Disclaimer = loadable(() => import("../Disclaimer"));
const LexusButton = loadable(() => import("../LexusButton"));
const Link = loadable(() => import("../Link"));
const Typography = loadable(() => import("../Typography"));
const Icon = loadable(() => import("../../_nextgen/components/Icon"));
const RenderContent = loadable(() => import("../RenderContent"));
const { DynamicHeading, DynamicHeadingLevelProvider, H1, H2, H3, H4, H5, H6 } =
	loadable(() => import("../DynamicHeading"));
const CollisionCenterLink = loadable(() => import("../CollisionCenterLink"));
const Spec = loadable(() => import("../SpecsHighlight/SpecHighlight/Spec"));

const Private = ({ children }) => <span data-cs-mask="">{children}</span>;

export const configureText = (props = {}) =>
	configureHtmlText({
		a: Link,
		LexusButton,
		Disclaimer,
		disclaimer: Disclaimer,
		InlineDisclaimer,
		MobileBreakpoint,
		TabletBreakpoint,
		DesktopBreakpoint,
		XLDesktopBreakpoint,
		Icon,
		Typography,
		RenderContent,
		Private,
		DynamicHeading,
		DynamicHeadingLevelProvider,
		H1,
		H2,
		H3,
		H4,
		H5,
		H6,
		CollisionCenterUrl: CollisionCenterLink,
		Spec,
		...props,
	});

const Text: FC<PropsWithChildren & TextProps> = configureText();

export default Text;
